<template>
  <section class="bg-white rounded-lg border border-gray-200">
    <header class="flex items-center gap-3 px-4 py-3 border-b border-gray-200" :class="{ 'border-b-0': collapsed }">
      <h2 class="text-[14px] font-semibold text-gray-900">{{ title }}</h2>
      <span v-if="meta" class="text-gray-500">{{ meta }}</span>
      <div class="ml-auto flex items-center gap-3">
        <slot name="actions" />
        <button v-if="collapsible" type="button" class="text-gray-500 hover:text-gray-900" @click="collapsed = !collapsed">
          {{ collapsed ? 'Expand' : 'Collapse' }}
        </button>
      </div>
    </header>
    <div v-show="!collapsed" :class="[flush ? '' : 'p-4', height ? 'overflow-y-auto' : '']" :style="height ? { maxHeight: `${height}px` } : null">
      <slot />
    </div>
  </section>
</template>

<script>
export default {
  name: 'HermesCard',
  props: {
    title: { type: String, required: true },
    meta: { type: String, default: '' },
    collapsible: { type: Boolean, default: false },
    startCollapsed: { type: Boolean, default: false },
    flush: { type: Boolean, default: false },
    height: { type: Number, default: 0 },
  },
  data() {
    return { collapsed: this.startCollapsed };
  },
};
</script>
